<div class="modal-login-body d-flex flex-column position-relative">
  @switch(currentFunction()){ @case (modalFunctions.LOGIN) {
  <app-login
    [isInModal]="true"
    class="d-flex flex-column flex-fill"
    (loginDone)="close($event)"
    (requestRegister)="currentFunction.set(modalFunctions.REGISTER)"
  ></app-login>
  } @case(modalFunctions.REGISTER) {
  <app-register
    [isInModal]="true"
    class="d-flex flex-column flex-fill"
    (registerDone)="close(true)"
    (requestLogin)="currentFunction.set(modalFunctions.LOGIN)"
  ></app-register>
  } }
  <div class="position-absolute left-0 top-0 right-0 p-3 w-100">
    <div class="d-flex justify-content-between align-items-center mb-2 w-100">
      <div class="col-1"></div>
      <div class="text-center text-white">
        <h5 class="m-0" translate>Login or sign up</h5>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
    </div>
    <hr class="text-white" />
  </div>
</div>
